<template>
    <section class="inline welcome large bg-brand">
        <div class="grid gap-3 fixed fixed-max-sm middle xs-grid-cols-1 sm-grid-cols-2 ">
            <div class="img">
                <slot name="img"></slot>
            </div>
            <div class="flex vertical large top center">
                <slot name="content"></slot>
            </div>
        </div>
    </section>
</template>
<script src="./mvt-welcome.js"></script>